import { ChangeEvent, FormEvent, useEffect, useState } from 'react'
import { SdirButton, TextField } from '@sdir/sds'
import { useLocation, useNavigate } from 'react-router-dom'
import { useLanguage } from '@i18n'
import './SearchForm.css'

export const SearchForm = () => {
  const [query, setQuery] = useState('')
  const [showRequiredError, setShowRequiredError] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useLanguage()

  useEffect(() => {
    if (location.pathname.startsWith('/vessels/vessel/')) {
      setQuery('')
      setShowRequiredError(false)
    }
  }, [location.pathname])

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const trimmedQuery = query.trim()
    if (!trimmedQuery) {
      setShowRequiredError(true)
      return
    }

    setShowRequiredError(false)
    navigate(`/vessels?query=${encodeURIComponent(trimmedQuery)}`)
  }

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value)
    if (showRequiredError) {
      setShowRequiredError(false)
    }
  }

  return (
    <section className="search-form" aria-labelledby="vessel-certificate-search-heading">
      <div className="search-form__inner">
        <h1 className="search-form__title" id="vessel-certificate-search-heading">
          {t('header.searchHeading')}
        </h1>
        <form className="search-form__form" role="search" noValidate onSubmit={handleSubmit}>
          <TextField
            id="certificate-search"
            name="certificate-search"
            type="search"
            label={t('header.searchLabel')}
            placeholder={t('header.searchPlaceholder')}
            value={query}
            invalid={showRequiredError}
            novalidate
            error={showRequiredError ? t('common.requiredField') : null}
            onChange={handleSearchChange}
          />
          <SdirButton
            className="search-form__submit"
            htmlType="submit"
            type="primary"
            text={t('common.search')}
          />
        </form>
      </div>
    </section>
  )
}

export default SearchForm
